module.exports = __webpack_public_path__ + "img/arrow-next.d33728ca.svg";